import { RadioButtonNew, RadioGroupNew } from "@octopusdeploy/design-system-components";
import { ExpandableFormSection, Summary } from "~/components/form";
type ProjectsPageOnboardingFeatureProps = {
    isEnabled: boolean;
    onChange: (isEnabled: boolean) => void;
};
export function ProjectsPageOnboardingFeature({ isEnabled, onChange }: ProjectsPageOnboardingFeatureProps) {
    const description = "When this setting is on, the Projects page can show an onboarding state. It appears when there is exactly one project in a space and it has not been deployed yet.";
    const key = "IsProjectsPageOnboardingEnabled";
    const label = "Projects Page Onboarding";
    const name = "ProjectsPageOnboarding";
    return (<ExpandableFormSection key={key} errorKey={key} title={label} summary={isEnabled ? Summary.default("Enabled") : Summary.summary("Disabled")} help={description}>
            <RadioGroupNew value={isEnabled} onChange={onChange} label={label} description={description} hideLabel={true} hideDescription={true}>
                <RadioButtonNew value={true} label="Enabled" name={name} hasDefaultMarker={true}/>
                <RadioButtonNew value={false} label="Disabled" name={name}/>
            </RadioGroupNew>
        </ExpandableFormSection>);
}
